import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "button"]
  static values = {
    collapsedHeight: { type: Number, default: 160 },
    collapsed: { type: Boolean, default: true },
    collapsedLabel: { type: String, default: "もっと見る" },
    expandedLabel: { type: String, default: "閉じる" }
  }

  connect() {
    // If content fits within collapsed height, hide button
    this.applyInitialState()
  }

  applyInitialState() {
    const contentEl = this.contentTarget
    const needsCollapse = contentEl.scrollHeight > this.collapsedHeightValue

    if (needsCollapse && this.collapsedValue) {
      this.collapse()
      this.showButton()
    } else if (needsCollapse) {
      this.expand()
      this.showButton()
    } else {
      this.expand()
      this.hideButton()
    }
  }

  toggle() {
    if (this.collapsedValue) {
      this.expand()
    } else {
      this.collapse()
    }
  }

  collapse() {
    const contentEl = this.contentTarget
    contentEl.style.maxHeight = `${this.collapsedHeightValue}px`
    contentEl.style.overflow = "hidden"
    this.collapsedValue = true
    this.updateButtonLabel()
  }

  expand() {
    const contentEl = this.contentTarget
    contentEl.style.maxHeight = ""
    contentEl.style.overflow = ""
    this.collapsedValue = false
    this.updateButtonLabel()
  }

  showButton() {
    if (this.hasButtonTarget) this.buttonTarget.classList.remove("hidden")
  }

  hideButton() {
    if (this.hasButtonTarget) this.buttonTarget.classList.add("hidden")
  }

  updateButtonLabel() {
    if (!this.hasButtonTarget) return
    this.buttonTarget.textContent = this.collapsedValue ? this.collapsedLabelValue : this.expandedLabelValue
  }
}
